module.exports = __webpack_public_path__ + "static/media/8OLA15.b2a84679.jpg";